import { SelectCode } from "./select-code.model";

export class SelectCodeValue extends SelectCode {
  value: string | null = null;
}